// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorMessage {
  font-size: 12px;
  color: #CC0101;
}
.actions {
  align-items: center;
  display: flex;
  padding-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/CollectionBox.less"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,cAAA;AADF;AAIA;EACE,mBAAA;EACA,aAAA;EACA,iBAAA;AAFF","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.errorMessage {\n  font-size: 12px;\n  color: @error-color;\n}\n\n.actions {\n  align-items: center;\n  display: flex;\n  padding-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
